import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';

/*Actions*/
import {
	saveSelectedAccountsAllPriceSources,
	saveSelectedAccountAndPriceSource,
	saveAccountDetail,
	updateUserASMOrNot,
	resetOrderObjectInStoreException,
	logout,
	saveSelectedAddressBackup
} from '../../redux/actions';

import {
	manipulateClipBoardToKeepNumericsOnly
} from '../../redux/util';
import GenericOverlayDialog from '../dialogs/genericOverlayDialog';

class SelectAccountAndPriceSourceOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
			showOauthMessageForEmployeeUserDialog : false,
            param: {
                selectedAccount: '',
                selectedPriceSource: '',
            },
            error: {
                selectedAccountError: '',
                selectedPriceSourceError: ''
            },
            accountList: [],
            accountNumber: '',
			gotAccountDetails: false,

			isDefaultSalesAgreement: null,
        };
		this.closeDialog = this.closeDialog.bind(this);
		this.checkIfAnyDefaultSalesAgreement = this.checkIfAnyDefaultSalesAgreement.bind(this);
		this.resetError = this.resetError.bind(this);
		this.handleDialog = this.handleDialog.bind(this);
    }

    closeDialog(event) {
		const self = this;
		if (this.props.isPunchOut || self.state.isDefaultSalesAgreement) {
			self.handlePriceSourceChange({
				target: {
					value: this.props.isPunchOut ? this.props.punchOutSalesNumber : self.state.param.selectedPriceSource
				}
			});
		} else {
			const currentAccountNumber = (self.accountNumberInput && self.accountNumberInput.value) || self.state.param.selectedAccount;
	    	if(self.state.alreadySelectedAccount && self.state.alreadySelectedAccount.ACCOUNTNUMBER !== currentAccountNumber &&
				!self.state.error.selectedAccountError
				&& self.state.gotAccountDetails
			) {
				self.accountNumberInput.value = self.state.alreadySelectedAccount.ACCOUNTNUMBER;
				const accountNumber = self.state.alreadySelectedAccount.ACCOUNTNUMBER;

				// reset all sales agreement
				self.props.saveSelectedAccountsAllPriceSources(null);
				self.setState({
					gotAccountDetails: false,
				}, () => {
					if(accountNumber) {
						//Get account details and then address list of that account
						self.props.getAccountDetailsAndAddressList(accountNumber, true, self.props.state.user.userDetails, response => {
							if(response.status && response.responseObject && response.responseObject.length > 0) {
								self.setState({
									showDialog: false,
									gotAccountDetails: true,
								}, () => {
									self.props.saveAccountDetail(response);
									self.props.getPriceSources(accountNumber, true, responseObject => {
										self.checkIfUserIsASM(responseObject);
									});
									self.props.handleDialog && self.props.handleDialog("SelectAccountAndPriceSourceOverlayDialog", false);
								});
							} else {
								self.setState({
						            showDialog: false
						        }, () => {
									self.props.handleDialog && self.props.handleDialog("SelectAccountAndPriceSourceOverlayDialog", false);
								});
							}
						});
					} else {
						self.setState({
				            showDialog: false
				        }, () => {
							self.props.handleDialog && self.props.handleDialog("SelectAccountAndPriceSourceOverlayDialog", false);
						});
					}
				});
			} else {
				self.setState({
		            showDialog: false
		        }, () => {
					self.props.handleDialog && self.props.handleDialog("SelectAccountAndPriceSourceOverlayDialog", false);
				});
			}
		}
    }

	componentWillMount() {
		const {user} = this.props.state;
		if(user.userDetails.isOktaLogin == false && user.userDetails.typeOfUser == 'employee'){
			this.setState({
				genericDialogHeading: "Login information",
				genericDialogText: '<p>Please use the blue GE Appliances Employee Login button. </p>',
				modalButtons: 'ok',
				showOauthMessageForEmployeeUserDialog : true
			}, () => {
				this.handleDialog('GenericOverlayDialog', true);
			});
			return;
		}
		this.setState({
			alreadySelectedAccount: user.selectedAccount
		});
		if(user.selectedAccount && user.selectedPriceSource) {
			this.setState({
				param: {
					selectedAccount: user.selectedAccount.ACCOUNTNUMBER,
					selectedPriceSource: user.selectedPriceSource.AGREEMENT_NUMBER,
				}
			});

			if(!user.selectedAccountsAllPriceSources || (user.selectedAccountsAllPriceSources && !user.selectedAccountsAllPriceSources.responseObject)) {
				this.props.getPriceSources(user.selectedAccount.ACCOUNTNUMBER, true, responseObject => {
					self.checkIfUserIsASM(responseObject);
				});
			}
		}
	}

	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		//this.handlePriceSourceChanges();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

    componentDidMount() {
		// window.scrollTo(0, 0);
        let {user} = this.props.state,
	        acccountListDropDown = [],
			accountNumber = "";

		let accountList = user && user.approvedAccounts && user.approvedAccounts.responseObject?user.approvedAccounts.responseObject:[];
		accountList.map((item, index) => {
			if(item.STATUS === "A") {
				accountNumber = item.ACCOUNTNUMBER;
				acccountListDropDown.push(<option key={index} value={item.ACCOUNTNUMBER}>{item.ACCOUNTNUMBER} - {item.ACCOUNTDESCRIPTION}</option>);
			}
			return null;
		});
		acccountListDropDown.sort((a, b) => Number(a.props.value) - Number(b.props.value));

        this.setState({
            showDialog: this.props.showDialog,
            accountList: acccountListDropDown
        });

		if(accountList.length === 1) {
			this.setState({
				param: {
					selectedAccount: accountNumber
				}
			});
			this.handleAccountNumberChange({
				target: {
					value: accountNumber
				}
			});
		}
		if(this.props.isPunchOut){
			this.handleAccountNumberSubmit(null, this.props.punchOutAccNumber);
		}
			
    }

	handlePriceSourceChange(event) {
		const self = this;
		self.setState({
			param: {
				...self.state.param,
				selectedPriceSource: event.target.value
			}
		}, () => {
			if(self.state.param.selectedPriceSource) {
				const { accountDetail, selectedAccountsAllPriceSources } = self.props.state.user;

				// let selectedAccountDetails = {};
				// if(userDetails && userDetails.typeOfUser === 'employee') {
				// 	selectedAccountDetails = accountDetail.responseObject[0];
				// } else {
				// 	selectedAccountDetails = approvedAccounts && approvedAccounts.responseObject && _.find(approvedAccounts.responseObject, ['ACCOUNTNUMBER', this.state.param.selectedAccount]);
				// }
				// selectedAccountDetails = accountDetail.responseObject[0];
				const anyAlreadySelectedAccount = self.state.alreadySelectedAccount;
				self.setState({
					alreadySelectedAccount: null
				}, () => {
					const data = {
						selectedAccount: accountDetail.responseObject[0],
						selectedPriceSource: selectedAccountsAllPriceSources && selectedAccountsAllPriceSources.responseObject && _.find(selectedAccountsAllPriceSources.responseObject, ['AGREEMENT_NUMBER', parseInt(this.state.param.selectedPriceSource, 10)]),
					}
					// clear delivery method from backuped object if there is any
					self.props.clearDeliveryMethodFromBackup();

					// update store with selected account detail and sales agreement
					self.props.saveSelectedAccountAndPriceSource(data);
					// save selected account number and sales agreement to localstorage
					self.props.saveSelectedAccountAndPriceSourceToLocalStorage(data.selectedAccount, data.selectedPriceSource, selectedAccountsAllPriceSources);

					// reset orders reducer
					self.props.resetOrderObjectInStoreException();
					// set default adc after changing of sales agreement
					self.props.state.user.selectedAddress && self.props.setDefaultADC(JSON.parse(self.props.state.user.selectedAddress), accountDetail.responseObject[0].ACCOUNTNUMBER);
					// Make home page service call
					const typeOfAccount = data.selectedAccount.SALESCHANNELCODE || data.selectedAccount.SALESCHANNEL;
					if(typeOfAccount === 'CONTRACT' || typeOfAccount === 'PRO CHANNEL' || typeOfAccount === 'HQ') {
						self.setState({
				            showDialog: false
				        }, () => {
							self.props.handleDialog && self.props.handleDialog("SelectAccountAndPriceSourceOverlayDialog", false);
						});
						self.props.fetchHomePageAssets();
					} else {
						self.setState({
				            showDialog: false
				        }, () => {
							self.props.handleDialog && self.props.handleDialog("SelectAccountAndPriceSourceOverlayDialog", false);
						});
					}
					if(anyAlreadySelectedAccount && anyAlreadySelectedAccount.ACCOUNTNUMBER !== data.selectedAccount.ACCOUNTNUMBER) {
						browserHistory.push('/home');
					}
				});
			}
		});
	}

    handleAccountNumberChange(event) {
		const accountNumber = event.target.value;
		if(accountNumber) {
			let self = this;
			self.setState({
				param: {
					...this.state.param,
					selectedAccount: accountNumber
				}
			});
			self.props.getPriceSources(accountNumber, true, responseObject => {
				self.checkIfAnyDefaultSalesAgreement(responseObject);
				self.checkIfUserIsASM(responseObject);
			});
			//Get account details and then address list of that account
			self.props.getAccountDetailsAndAddressList(accountNumber, true, self.props.state.user.userDetails);
			browserHistory.push('/home');
		}
    }

	checkIfUserIsASM(responseObject) {
		const self = this;
		const {
			userDetails
		} = self.props.state.user;
		if (userDetails && !userDetails.isASM) {
			const {
				firstName,
				lastName,
			} = userDetails;
			let isASM = false;
			responseObject.forEach(item => {
				if (item.SALESPERSON && item.SALESPERSON.indexOf(lastName) !== -1 && item.SALESPERSON.indexOf(firstName) !== -1) {
					isASM = true;
				}
			});
			// ASM Admin access - Add SA
			self.props.updateUserASMOrNot(isASM);
		}
	}

	checkIfAnyDefaultSalesAgreement(salesAgreementList) {
		const self = this;
		const defaultSA = salesAgreementList.find(itm => itm["Default Sales Agreement"] === 'Y');
		self.setState({
			isDefaultSalesAgreement: defaultSA,
			param: {
				...self.state.param,
				selectedPriceSource: defaultSA ? defaultSA.AGREEMENT_NUMBER : self.state.param.selectedPriceSource
			}
		});
	}

	handleAccountNumberSubmit(event, accountNumberVal = null) {
		event && event.preventDefault();
		const self = this,
		accountNumber = accountNumberVal ? accountNumberVal : this.accountNumberInput.value;

		self.props.clearPartsSearchData();
		if (self.props.state.user.selectedAddressBackup) {
			self.props.saveSelectedAddressBackup(null);
		}
		// reset all sales agreement
		self.props.saveSelectedAccountsAllPriceSources(null);
		self.setState({
			gotAccountDetails: false,
		}, () => {
			if(accountNumber) {
				//Get account details and then address list of that account
				self.props.getAccountDetailsAndAddressList(accountNumber, true, self.props.state.user.userDetails, response => {
					if(response.status && response.responseObject && response.responseObject.length > 0 && response.responseObject[0].STATUS === "A") {
						self.setState({
							param: {
								...this.state.param,
								selectedAccount: accountNumber
							},
							gotAccountDetails: true,
						});
						self.props.saveAccountDetail(response);
						self.props.getPriceSources(accountNumber, true, responseObject => {
							self.checkIfAnyDefaultSalesAgreement(responseObject);
							self.checkIfUserIsASM(responseObject);
							if(this.props.isPunchOut){
								this.setState({
									showDialog: false,
								});
								self.closeDialog(null);
							}
						});
					} else {
						self.setState({
							error: {
								...self.state.error,
								selectedAccountError: 'error'
							}
						})
					}
				});
				browserHistory.push('/home');
			}
			self.setState({
				param: {
					...self.state.param,
					selectedPriceSource: ''
				},
				error: {
					selectedAccountError: accountNumber?'':'error',
					selectedPriceSource: ''
				}
			});
		});
	}

	logout(){
		const self =  this;
		self.setState({
			showOauthMessageForEmployeeUserDialog:false
		}, () => {
			self.props.logout();
		});
		
	}

	resetError(event) {
		this.setState({
			error: {
				selectedAccountError: '',
				selectedPriceSource: ''
			}
		})
	}

    render() {
		const self = this;
		const { user } = self.props.state;
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="selectAccountAndPriceSourceOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                	{(user && user.selectedAccount && user.selectedPriceSource) || self.state.isDefaultSalesAgreement
						?<a className="closeButton" onClick={this.closeDialog.bind(this)}>&times;</a>
						:null
					}
                    {/* //This has been specifically removed from this popup as all values are compulsory
                        <a className="closeButton" onClick=this.closeDialog.bind(this)}>×</a> */}
                    <h2 className="title">SELECT ACCOUNT & SALES AGREEMENT</h2>
                    <p><b>To continue using CustomerNet, please select an account and sales agreement below.</b></p>
                    <p>You will be able to change your selection at any point by clicking the change link located beneath your account.</p>
                    <p className={this.state.error.selectedAccountError}>
						{user.userDetails && user.userDetails.typeOfUser === 'employee' && !user.userDetails.isNonGEASsoUser
							?<span>
								<label className="bold">Enter an account:</label>&nbsp;
								<input
									type="text"
									className={this.state.error.selectedAccountError}
									onChange={this.resetError}
									onPaste={(e) => manipulateClipBoardToKeepNumericsOnly(this.resetError, e)}
									ref={(input) => { this.accountNumberInput = input; }}
									defaultValue={user.selectedAccount && user.selectedAccount.ACCOUNTNUMBER}
									name="accountNumber"
									onKeyPress={this.props.acceptNumbersOnly}
									style={{width: 155}}
								/>&nbsp;
								<input type="submit" onClick={this.handleAccountNumberSubmit.bind(this)} className="blueButton" value="GO"  />
							</span>
							:null
						}
                    	{user.userDetails && (user.userDetails.typeOfUser !== 'employee' || user.userDetails.isNonGEASsoUser) && this.state.accountList.length > 0
							?<select name="selectAccount" value={this.state.param.selectedAccount} onChange={this.handleAccountNumberChange.bind(this)} style={{width: '70%'}}>
	                            <option value="">Select Account</option>
	                            {this.state.accountList}
                        	</select>
                    		:null
						}
                    </p>
					{this.state.param.selectedAccount && user.selectedAccountsAllPriceSources && user.selectedAccountsAllPriceSources.responseObject
						?(user.selectedAccountsAllPriceSources.responseObject.length > 0
							?<p className={this.state.error.selectedPriceSourceError}>
								<select value={self.state.param.selectedPriceSource} id="selectPriceSourceD" onChange={this.handlePriceSourceChange.bind(this)} name="selectPriceSourceD" className="selectPriceSourceD" style={{width: '90%'}}>
									<option value="">Select Sales Agreement</option>
									{user.selectedAccountsAllPriceSources.responseObject.filter((itm)=>{
										return itm.PRICE_LIST_NAME != "APPLIANCES - BLEM LOAD PRICE LIST"
									}).map((item, index) => {
										return <option value={item.AGREEMENT_NUMBER} key={index}>{item.DISPLAY_AGREEMENT_NAME}</option>
									})}
								</select>
							</p>
							:<p className="red bold">No sales agreements found for the given account.</p>
						)
						:null
					}
                </div>
				{this.state.showOauthMessageForEmployeeUserDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="OauthMessageForEmployeeUserDialog" handleDialog={this.logout.bind(this)} showDialog={true} />:null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};
const mapDispatchToProps = (dispatch) => ({
	saveSelectedAccountsAllPriceSources: (data) => dispatch(saveSelectedAccountsAllPriceSources(data)),
	saveSelectedAccountAndPriceSource: (data) => dispatch(saveSelectedAccountAndPriceSource(data)),
	saveAccountDetail: (data) => dispatch(saveAccountDetail(data)),
	updateUserASMOrNot: (data) => dispatch(updateUserASMOrNot(data)),
	resetOrderObjectInStoreException: () => dispatch(resetOrderObjectInStoreException()),
	saveSelectedAddressBackup: address => dispatch(saveSelectedAddressBackup(address)),
	logout: () => dispatch(logout()),
});


SelectAccountAndPriceSourceOverlayDialog = connect(mapStateToProps, mapDispatchToProps)(SelectAccountAndPriceSourceOverlayDialog);
export default SelectAccountAndPriceSourceOverlayDialog;


// WEBPACK FOOTER //
// ./src/App/components/dialogs/selectAccountAndPriceSourceOverlayDialog.js